function safeName(value: string | null | undefined): string {
  if (!value) return 'UNKNOWN'
  return value.trim().replace(/[^\w-]/g, '_')
}

export interface EmailFileEntry {
  label: string
  filename: string
  docType: 'order_response' | 'despatch_advice' | 'invoice'
}

type DocType = 'order_response' | 'despatch_advice' | 'invoice'

function xmlFilename(docType: DocType, supplierGln: string, buyerGln: string, orId: string, daId: string, invId: string): string {
  const prefix = `${supplierGln}_${buyerGln}`
  if (docType === 'order_response') return `${prefix}_OR${orId}_OrderResponse.xml`
  if (docType === 'despatch_advice') return `${prefix}_OR${orId}_DespatchAdvice_DA${daId}.xml`
  return `${prefix}_OR${orId}_Invoice_DA${daId}_INV${invId}.xml`
}

interface SessionIds {
  ordrsp_supplier_gln?: string | null
  desadv_supplier_gln?: string | null
  invoice_supplier_gln?: string | null
  ordrsp_buyer_gln?: string | null
  desadv_buyer_gln?: string | null
  invoice_buyer_gln?: string | null
  order_response_number?: string | null
  desadv_number?: string | null
  invoice_number?: string | null
  // Verzendreferenties (aanwezig als sessie al eerder verstuurd is)
  sent_or_ref?: string | null
}

export function buildEmailFiles(
  session: SessionIds,
  presentDocs: { ordrsp: boolean; desadv: boolean; invoice: boolean },
): EmailFileEntry[] {
  // Gebruik de vorige verzendreferentie als preview indien beschikbaar,
  // anders de originele XML-nummers (eerste verzending — echte ref volgt na verzenden)
  const refSuffix = session.sent_or_ref ?? null
  const orId = refSuffix ? safeName(refSuffix) : safeName(session.order_response_number)
  const daId = refSuffix ? safeName(refSuffix) : safeName(session.desadv_number)
  const invId = refSuffix ? safeName(refSuffix) : safeName(session.invoice_number)

  // Elk document krijgt zijn eigen GLN; fallback naar de andere als die ontbreekt
  const buyerGlnFallback = safeName(session.invoice_buyer_gln ?? session.ordrsp_buyer_gln ?? session.desadv_buyer_gln)
  const docGlns = {
    order_response: safeName(session.ordrsp_supplier_gln ?? session.invoice_supplier_gln ?? session.desadv_supplier_gln),
    despatch_advice: safeName(session.desadv_supplier_gln ?? session.ordrsp_supplier_gln ?? session.invoice_supplier_gln),
    invoice: safeName(session.invoice_supplier_gln ?? session.ordrsp_supplier_gln ?? session.desadv_supplier_gln),
  }
  const docBuyerGlns = {
    order_response: safeName(session.ordrsp_buyer_gln) || buyerGlnFallback,
    despatch_advice: safeName(session.desadv_buyer_gln) || buyerGlnFallback,
    invoice: safeName(session.invoice_buyer_gln) || buyerGlnFallback,
  }

  const entries: EmailFileEntry[] = []
  if (presentDocs.ordrsp) entries.push({ label: 'OrderResponse', docType: 'order_response', filename: xmlFilename('order_response', docGlns.order_response, docBuyerGlns.order_response, orId, daId, invId) })
  if (presentDocs.desadv) entries.push({ label: 'DespatchAdvice', docType: 'despatch_advice', filename: xmlFilename('despatch_advice', docGlns.despatch_advice, docBuyerGlns.despatch_advice, orId, daId, invId) })
  if (presentDocs.invoice) entries.push({ label: 'Invoice', docType: 'invoice', filename: xmlFilename('invoice', docGlns.invoice, docBuyerGlns.invoice, orId, daId, invId) })
  return entries
}
